
import { common } from './common/de';
import { products } from './products/de';
import { pricing } from './pricing/de';
import { solutions } from './solutions/de';

export const de = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
